/* eslint-disable max-len */
import React, { useMemo } from 'react';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
// import { DeleteModalIcon } from '../../media/images/DeleteModalIcon';
import { useSelector } from 'react-redux';
import warningLogo from '../../../../../../assets/warning.svg';
import styles from './AddScheduleConfirmationModalStyle.module.scss';
import { RootState } from '../../../../../../redux/rootState';
import { convertDateFormat } from '../../../../../../utils/CommonFunctions';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 650,
  height: 'auto',
  bgcolor: 'background.paper',
  borderRadius: '6px',
  boxShadow: 24,
  p: 5,
  '@media (max-width: 768px)': {
    width: '90%',
  },
};
type TypesConfirmModal = {
  show: boolean;
  setOpenFrom: () => void;
  callback: () => void;
  analystName: string;
};

export default function AddScheduleConfirmationModal({
  show, setOpenFrom, callback, analystName,
}: TypesConfirmModal): JSX.Element {
  const { eventListWithinDate } = useSelector((state: RootState) => state.CalenderReducer);

  const [vacations, sickLeaves, appointments, jobs] = useMemo(() => {
    if (eventListWithinDate) {
      const vac = eventListWithinDate?.[0]?.Events?.filter((item) => item?.EventId === 1);
      const vacStr = vac?.map((item) => (item?.StartDate === item?.EndDate ? convertDateFormat(item?.StartDate) : `${convertDateFormat(item?.StartDate)} to ${convertDateFormat(item?.EndDate)}`))?.join(', ');
      const sic = eventListWithinDate?.[0]?.Events?.filter((item) => item?.EventId === 2);
      const sickSt = sic?.map((item) => (item?.StartDate === item?.EndDate ? convertDateFormat(item?.StartDate) : `${convertDateFormat(item?.StartDate)} to ${convertDateFormat(item?.EndDate)}`))?.join(', ');
      const app = eventListWithinDate?.[0]?.Events?.filter((item) => item?.EventId === 3);
      const appStr = app?.map((item) => (item?.StartDate === item?.EndDate ? convertDateFormat(item?.StartDate) : `${convertDateFormat(item?.StartDate)} to ${convertDateFormat(item?.EndDate)}`))?.join(', ');
      const job = eventListWithinDate?.[0]?.Events?.filter((item) => item?.EventId === 4);
      const jobStr = job?.map((item) => (item?.StartDate === item?.EndDate ? convertDateFormat(item?.StartDate) : `${convertDateFormat(item?.StartDate)} to ${convertDateFormat(item?.EndDate)}`))?.join(', ');
      return [vacStr, sickSt, appStr, jobStr];
    } return [[], [], [], []];
  }, [eventListWithinDate]);

  return (
    <Modal
      open={show}
      onClose={setOpenFrom}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <div className={styles.deleteIcon}>
          {/* <DeleteModalIcon /> */}
          <img src={warningLogo} alt="Warning" height={100} width={100} />
        </div>
        <div className={styles.modalModalHeading}>
          Are you sure?
        </div>
        <div className={styles.modalModalDescription}>
          {analystName?.length > 0 ? analystName : 'This analyst'}
          &nbsp;
          has below events scheduled within the selected date range:
        </div>
        <div className={styles.modalDescriptionContainer}>
          {vacations?.length > 0 && (
          <div className={styles.modalModalDescriptionRed}>
            <p>Vacations</p>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          &nbsp;&nbsp;&nbsp;:&nbsp;
            <p>{vacations}</p>
          </div>
          )}
          {sickLeaves?.length > 0 && (
          <div className={styles.modalModalDescriptionRed}>
            <p>Sick Leaves</p>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:&nbsp;
            <p>{sickLeaves}</p>
          </div>
          )}
          {appointments?.length > 0 && (
          <div className={styles.modalModalDescriptionGreen}>
            <p>Appointments</p>
          &nbsp;&nbsp;:&nbsp;
            <p>{appointments}</p>
          </div>
          )}
          {jobs?.length > 0 && (
          <div className={styles.modalModalDescriptionGreen}>
            <p>Jobs Sch.</p>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          &nbsp;:&nbsp;
            <p>{jobs}</p>
          </div>
          )}
        </div>
        <div className={styles.modalModalDescriptionWithMargin}>
          Do you still want to proceed?
        </div>

        <div className={styles.divButtons}>
          <button
            type="button"
            className={`btn ${styles.deleteBtn}`}
            onClick={callback}
          >
            YES
          </button>
          <button type="button" className={`btn ${styles.cancelBtn}`} onClick={setOpenFrom}>NO</button>
        </div>
      </Box>
    </Modal>
  );
}
